/**
 * Extracts a query parameter value from the current URL.
 * Handles both hash routing (e.g., #/path?param=value) and regular URLs.
 *
 * @param paramName - The name of the query parameter to retrieve
 * @returns The value of the query parameter, or null if not found
 */
export function getQueryParamFromHash(paramName: string): string | null {
    const hash = window.location.hash;

    // Check if we have hash routing with query parameters
    if (hash?.includes('?')) {
        // Extract query string from hash (everything after the ? in the hash)
        const hashQueryString = hash.split('?')[1];
        const hashParams = new URLSearchParams(hashQueryString);
        const hashValue = hashParams.get(paramName);

        if (hashValue !== null) {
            return hashValue;
        }
    }

    // Fall back to regular search params if not found in hash or no hash query params
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(paramName);
}
